import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import {ComponentsModule} from "../../components/components.module";
import {PopoverCyclecountProgressPage} from "./popover-cyclecount-progress";
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  declarations: [
    PopoverCyclecountProgressPage,
  ],
  imports: [
    ComponentsModule,
    IonicPageModule.forChild(PopoverCyclecountProgressPage),
    TranslateModule.forChild()
  ],
})
export class PopoverCyclecountProgressPageModule {}



// WEBPACK FOOTER //
// ./src/pages/popover-cyclecount-progress/popover-cyclecount-progress.module.ts